import { classNames } from "primereact/utils";

import { Dropdown } from "../../../dropdown";
import { usePageHeaderContext } from "../../page-header.context";
import styles from "../../page-header.module.scss";
import type { PageHeaderTabSelectViewModel } from "./types-tab-select";

/** Versão mobile das abas: `Dropdown` do DS que navega para a rota escolhida. */
export function PageHeaderTabSelectView({
  options,
  value,
  onChange,
  ariaLabel,
  className,
  rest,
}: PageHeaderTabSelectViewModel) {
  const { classNames: parts, partTestId } = usePageHeaderContext();

  return (
    <div className={classNames(styles.tabSelect, parts.tabs, className)} {...rest}>
      <Dropdown
        options={options}
        optionDisabled="disabled"
        value={value}
        onChange={onChange}
        aria-label={ariaLabel}
        appendTo="self"
        data-testid={partTestId("seletor")}
      />
    </div>
  );
}
